import styled, { css } from 'styled-components';
import { borderRadius } from '../_styles/borderRadius';
import { colors } from '../_styles/colors';
import { getShadow } from '../_styles/shadows';
export var StyledCardContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCardContainer",
  componentId: "core-12_20_2__sc-2fii7b-0"
})(["background-color:", ";border-radius:", "px;transition:box-shadow 0.2s ease-in-out;", " ", ""], colors.white, borderRadius.md, function (_ref) {
  var $level = _ref.$level,
    $shadowStrength = _ref.$shadowStrength;
  var strength = $level ? Number($level) / 10 : $shadowStrength;
  return getShadow(strength);
}, function (_ref2) {
  var $variant = _ref2.$variant,
    $shadowStrength = _ref2.$shadowStrength;
  return $variant === 'hoverable' && css(["&:hover{", ";}"], getShadow($shadowStrength + 1));
});
//# sourceMappingURL=Card.styles.js.map